import React, { useEffect, useState } from "react";
import { BiPencil } from "react-icons/bi";
import { BsInfoCircle } from "react-icons/bs";
import { CiLocationOn, CiMail } from "react-icons/ci";
import { PiPhoneCallLight } from "react-icons/pi";
// import { TbCalendarPlus } from "react-icons/tb";
// import { MdOutlineNoteAdd } from "react-icons/md";
import { HiOutlineClipboard } from "react-icons/hi2";
import { IoBookOutline } from "react-icons/io5";
// import { HiOutlineUserAdd } from "react-icons/hi";
import { HiOutlineUsers } from "react-icons/hi2";

// import { FiServer } from "react-icons/fi";
import { CiStar } from "react-icons/ci";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./TMSshare.css";
import axios from "axios";

const TMSshare = () => {
  const [teacherProfile, setTeacherProfile] = useState();
  const [requestId, setRequestId] = useState("");
  const [teachersId, setTeachersId] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const { id } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    setRequestId(id);
  }, [API_BASE_URL]);

  useEffect(() => {
    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/teachers`
        : `${API_BASE_URL}/admin/teachers`;

    axios
      .get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response.data?.data);
        setTeacherProfile(response.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const toggleSelectTeachers = (e) => {
    if (teachersId.includes(e.target.value)) {
      setTeachersId((prev) => prev.filter((item) => item !== e.target.value));
    } else {
      setTeachersId((prev) => [...prev, e.target.value]);
    }
  };

  // console.log("request id", requestId);
  // console.log("teachers id ", teachersId);

  const handleSubmit = async () => {
    if (teachersId.length === 0) {
      alert("Please select atleast one teacher.");
      return;
    }
    try {
      await axios
        .post(
          `${API_BASE_URL}/admin/home-tutor/assign`,
          {
            requestId,
            teacherId: teachersId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          console.log(response);
          alert(response.data?.message);
          navigate("/home-tutor/tuition-management-system");
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {/* <button
        className="new-chapter-submit-btn position-fixed bottom-0 end-0"
        onClick={handleSubmit}
      >
        Submit
      </button> */}
      <div id="teacher-profile-container">
        <div className="d-flex w-100 justify-content-between align-items-center ">
          <h1>
            <b>Teacher's Profile</b>
          </h1>
          <button
            className="new-chapter-submit-btn "
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
        <div className="teacher-profile-inner-div">
          {teacherProfile &&
            teacherProfile.map((data, idx) => (
              <div
                className="teacher-profile-card-container d-flex flex-column align-items-start p-2 border border-2"
                key={idx}
              >
                <div className="ps-4 fs-5">
                  <label htmlFor="selectTeacher">Select Teacher : </label>
                  <input
                    type="checkbox"
                    id="selectTeacher"
                    value={data._id}
                    onChange={toggleSelectTeachers}
                    className="ms-2 fs-5 form-check-input mb-2"
                  />
                </div>
                <div className="w-100 d-flex">
                  <div className="teacher-profile-share-teacher-image-box">
                    <img
                      src={`${API_BASE_URL}/uploads/${data.basicInfo.profilePicture}`}
                      alt="teacher-img"
                    />
                  </div>

                  <div className="teacher-profile-teacher-details-box">
                    <p className="student-name-b">
                      <b>{data.basicInfo.fullName}</b>
                      <br />
                      <span style={{ color: "#404040", fontSize: "18px" }}>
                        <CiStar />
                        <CiStar />
                        <CiStar />
                        <CiStar />
                        <CiStar />
                      </span>
                    </p>
                    <p className="student-phone-and-email">
                      <span className="student-contact">
                        <PiPhoneCallLight className="icon-margin" />
                        {data.basicInfo?.contactNumber}
                      </span>
                      <span className="student-email">
                        <CiMail className="icon-margin" />
                        {data.basicInfo?.email}
                      </span>
                    </p>
                    <p className="student-address">
                      <CiLocationOn className="icon-margin" />
                      {data.basicInfo?.address}
                    </p>
                    <p className="teacher-accept-class-checks-boxes">
                      {/* <div>
                      <HiOutlineClipboard />
                    </div> */}
                      <div className="d-flex flex-column gap-2">
                        {data.professionalInfo?.teachingDetails.map(
                          (item, idx) => (
                            <div key={idx} className="w-100">
                              <HiOutlineClipboard className="icon" />
                              {item.className} -{" "}
                              <span>
                                <IoBookOutline className="icon" />
                                {item?.subjects.map((sub, idx) => (
                                  <span key={idx}>{sub.subjectName} , </span>
                                ))}
                              </span>{" "}
                            </div>
                          )
                        )}
                      </div>
                    </p>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

export default TMSshare;
